<template>
  <div>
    <p style="margin-bottom:15px">
      目前可提現金額: {{ balanceData.balance | decimalPoint }}
    </p>
    <el-dialog width="375px" title="確認提現" :visible.sync="applyModal">
      <el-form :model="bankInfo" label-position="top" v-if="applyModal">
        <el-form-item label="帳戶">
          <el-input
            disabled
            :value="
              bankInfo.account + '-' + bankInfo.bank_name + '-' + bankInfo.alias
            "
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="金額">
          <el-input
            disabled
            :value="addDataData.amount"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手續費(單筆)">
          <el-input
            disabled
            :value="balanceData.withdraw_fee"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手續費(百分比)">
          <el-input
            disabled
            :value="
              addDataData.amount * 1 * (balanceData.withdraw_fee_rate * 1)
            "
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="applyModal = false" class="btn">關閉</div>
        <div @click="confirmApply" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="addDataData" ref="applyForm" :rules="rules">
      <el-form-item label="常用帳戶" prop="bank">
        <el-select
          filterable
          style="width:100%"
          v-model="addDataData.bank"
          placeholder="請選擇常用帳戶"
        >
          <el-option
            :label="bank.account + '-' + bank.bank_name + '-' + bank.alias"
            :value="bank.id"
            v-for="bank in dataList"
            :key="bank.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金額" prop="amount">
        <el-input
          v-model="addDataData.amount"
          type="number"
          placeholder="金額"
        ></el-input>
      </el-form-item>
      <el-form-item label="提款密碼" prop="withdraw_password">
        <el-input
          v-model="addDataData.withdraw_password"
          placeholder="提款密碼"
        ></el-input>
      </el-form-item>
      <el-form-item label="2FA驗證碼">
        <el-input
          v-model="addDataData.oneCode"
          placeholder="2FA驗證碼"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="apply()">申請提現</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        bank: [{ required: true, message: "請選擇帳戶", trigger: "blur" }],
        amount: [{ required: true, message: "請輸入金額", trigger: "blur" }],
        withdraw_password: [
          { required: true, message: "請輸入提款密碼", trigger: "blur" }
        ]
      },
      addDataData: {},
      dataList: [],
      balanceData: {},
      applyModal: false,
      bankInfo: {}
    };
  },
  methods: {
    confirmApply() {
      let sendData = {
        amount: this.addDataData.amount,
        user_bank_id: this.addDataData.bank,
        multiple: 1,
        withdraw_password: this.addDataData.withdraw_password,
        oneCode: this.addDataData.oneCode
      };
      this.$http.post(`/back/withdraws/apply`, sendData).then(res => {
        this.applyModal = false;
        if (res.data.code == 0) {
          this.addDataData = {};
          this.$message.success("成功");
          this.getBalance();
        }
      });
    },
    apply() {
      this.$refs.applyForm.validate(valid => {
        if (valid) {
          this.dataList.forEach(e => {
            if (e.id == this.addDataData.bank) {
              this.bankInfo.bank_name = e.bank_name;
              this.bankInfo.account = e.account;
              this.bankInfo.alias = e.alias;
            }
          });
          this.applyModal = true;
        }
      });
    },
    getBalance() {
      this.$http.get(`/back/withdraws/apply/balance`).then(res => {
        this.balanceData = res.data.data;
      });
    },
    getData() {
      this.$http.get(`/back/withdraws/apply/bank_acc`).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
        }
      });
    }
  },
  created() {
    this.getData();
    this.getBalance();
  }
};
</script>
